import authHeader from "@/services/auth/AuthHeader";
import axios from "axios";

class SystemService {
    getCacheInfo(){
        let url = '/api/superadmin/system/getCacheInfo';
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    emptyCache(){
        let url = '/api/superadmin/system/emptyCache';
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    getVivaCacheInfo(){
        let url = '/api/superadmin/system/getVivaCacheInfo';
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    emptyVivaCache(){
        let url = '/api/superadmin/system/emptyVivaCache';
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    // Lists every merchant user registered in Sync Gateway (name, granted channels, disabled flag).
    // SUPER_ADMIN only (server-enforced via the /api/superadmin/** rule).
    listSyncGatewayUsers(){
        let url = '/api/superadmin/system/listSyncGatewayUsers';
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    // Removes a single user from Sync Gateway. SUPER_ADMIN only. The merchant's devices can no longer
    // sync until the user is recreated.
    deleteSyncGatewayUser(username){
        let url = '/api/superadmin/system/deleteSyncGatewayUser';
        let basicAuth = authHeader();
        return axios.post(url, { username: username }, { headers: basicAuth });
    }

    // Aggregated turnover (omsetning) across a selection of merchants, broken down per channel
    // (POS/KIOSK/Webshop). SUPER_ADMIN only. `merchants` is an array of merchant slugs.
    getAggregatedTurnoverReport(merchants, fromDate, toDate){
        let url = '/api/superadmin/report/getAggregatedTurnoverReport';
        let basicAuth = authHeader();
        return axios.get(url, {
            headers: basicAuth,
            params: { merchants: (merchants || []).join(','), fromDate: fromDate, toDate: toDate }
        });
    }

}

export default new SystemService();
